import { FormikFileInputField } from '../../../input/FormikFileInputField/FormikFileInputField';
import { FileData } from '../../../shared/interfaces/file';
import { TemplateFormFieldProps } from '../../interfaces/template-form';
import { TemplateFormFilePickerFieldMetaProps } from './interfaces/template-form-file-picker-field-meta';

export function TemplateFormFilePickerField({
  field,
  form,
  meta,
  metadata,
  formDisabled
}: TemplateFormFieldProps) {
  const props = metadata as TemplateFormFilePickerFieldMetaProps;

  const onChange = (data: FileData | FileData[] | null) => {
    let content = null;

    if (Array.isArray(data)) {
      content = data.map(file => file.content);
    } else if (data) {
      content = data.content;
    }

    (async () => {
      await form.setFieldValue(field.name, content);
    })();
  };

  return (
    <FormikFileInputField
      field={field}
      form={form}
      meta={meta}
      name={field.name}
      value={field.value}
      id={field.name}
      {...props}
      onChangeEventHandler={onChange}
      disabled={props.disabled || formDisabled}
    />
  );
}
